/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiVoxtralScheduleBroadcastKeyPost$Params {
  broadcastKey: string;
}

export function apiVoxtralScheduleBroadcastKeyPost(http: HttpClient, rootUrl: string, params: ApiVoxtralScheduleBroadcastKeyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiVoxtralScheduleBroadcastKeyPost.PATH, 'post');
  if (params) {
    rb.path('broadcastKey', params.broadcastKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiVoxtralScheduleBroadcastKeyPost.PATH = '/api/voxtral-schedule/{broadcastKey}';
